import {
  CallTranscription,
  CommunicationCall,
  CommunicationConversation,
  CommunicationMessage,
  CursorPage,
  RecordingPlayback,
} from '../types';
import { instance } from './instance';

const data = <T>(response: { data: T | { data: T } }): T => {
  const body = response.data;
  return body && typeof body === 'object' && 'data' in body
    ? (body as { data: T }).data
    : (body as T);
};

export const communicationApi = {
  async getOrderConversations(orderId: number) {
    const response = await instance.get(
      `/communication/admin/orders/${orderId}/conversations`
    );
    return data<{ items: CommunicationConversation[] }>(response);
  },

  async getMessages(conversationId: string, cursor?: string) {
    const response = await instance.get(
      `/communication/admin/conversations/${conversationId}/messages`,
      { params: { limit: 50, cursor } }
    );
    return data<CursorPage<CommunicationMessage>>(response);
  },

  async getCalls(conversationId: string, cursor?: string) {
    const response = await instance.get(
      `/communication/admin/conversations/${conversationId}/calls`,
      { params: { limit: 50, cursor } }
    );
    return data<CursorPage<CommunicationCall>>(response);
  },

  async getRecording(callId: string) {
    const response = await instance.get(
      `/communication/calls/${callId}/recording`
    );
    return data<RecordingPlayback>(response);
  },

  async transcribeCall(callId: string, language = 'en-NG') {
    const response = await instance.post(
      `/communication/admin/calls/${callId}/transcription`,
      { language }
    );
    return data<CallTranscription>(response);
  },
};
